// src/App.js - Complete integration with new MVC architecture
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.css';

// Existing components
import AboutPage from './components/AboutPage';
import { ConfigProvider } from './components/ConfigProvider';
import DemoPage from './components/DemoPage';
import LandingPage from './components/LandingPage';
import LegalPages from './components/LegalPages';
import NotFoundPage from './components/NotFoundPage';
import PricingPage from './components/PricingPage';
import RegistrationFlow from './components/RegistrationFlow';
import SupportFAQPage from './components/SupportFAQPage';

// New MVC components
import LoginPage from './components/auth/LoginPage';
import ProtectedRoute from './components/auth/ProtectedRoute';
import DashboardLayout from './components/dashboard/DashboardLayout';
import { AuthProvider } from './hooks/useAuth';
import { features } from './config/features';

function App() {
  
  return (
    <ConfigProvider>
      <AuthProvider>
        <Router>
          <div className="App">
            <Routes>
              {/* ===== EXISTING MARKETING ROUTES (MAINTAINED) ===== */}
              <Route path="/" element={<LandingPage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/demo" element={<DemoPage />} />
              <Route path="/support" element={<SupportFAQPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/legal" element={<LegalPages />} />
              
              {/* ===== REGISTRATION & AUTH ROUTES ===== */}
              <Route path="/register" element={<RegistrationFlow />} />
              <Route path="/login" element={<LoginPage />} />
              
              {/* ===== NEW DASHBOARD ROUTES (PROTECTED) ===== */}
              <Route path="/dashboard" element={
                <ProtectedRoute>
                  <DashboardLayout />
                </ProtectedRoute>
              } />
              <Route path="/dashboard/services" element={
                <ProtectedRoute>
                  <Navigate to="/dashboard?tab=settings-services" replace />
                </ProtectedRoute>
              } />
              <Route path="/dashboard/calendar" element={
                <ProtectedRoute>
                  <Navigate to="/dashboard?tab=settings-calendar" replace />
                </ProtectedRoute>
              } />
              <Route path="/dashboard/settings" element={
                <ProtectedRoute>
                  <Navigate to="/dashboard?tab=settings-business" replace />
                </ProtectedRoute>
              } />

              {features.sipSetup && (
                <Route
                  path="/settings/voice-and-sip"
                  element={
                    <ProtectedRoute>
                      <Navigate to="/dashboard?tab=settings-voice" replace />
                    </ProtectedRoute>
                  }
                />
              )}
              
              {/* ===== CATCH-ALL 404 ===== */}
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </div>
        </Router>
      </AuthProvider>
    </ConfigProvider>
  );
}

export default App;
